// Per-chat flag tracking whether render_block has fired successfully
// at least once. Used by suggest_kernel as a precondition: kernels
// require a render spec to display their result, so suggesting a
// kernel before any render_block has happened only produces broken
// saves. Mirrors toolResultStore's pattern: the producing tool
// stamps the namespace on success, the consuming tool reads — no
// chat-state coupling, just shared chat-scoped module state.

const _rendered = new Set();  // namespaceKey

export function markRendered(namespaceKey) {
    _rendered.add(namespaceKey || "default");
}

export function hasRendered(namespaceKey) {
    return _rendered.has(namespaceKey || "default");
}

export function clearRendered(namespaceKey) {
    _rendered.delete(namespaceKey || "default");
}
